module.exports = __webpack_public_path__ + "media/images/loading-700711c8e07d4ec75f2b648ebdc4f515.svg";